import { render, staticRenderFns } from "./ContattiAllegati.vue?vue&type=template&id=4eee320a&"
import script from "./ContattiAllegati.vue?vue&type=script&lang=js&"
export * from "./ContattiAllegati.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports